
<template>
  <div class="prog-outer">
    <div class="prog-node" v-for="(step, index) in steps.steps">
      <small style="overflow:visible">
        {{clauses[step.progLabel]}}
      </small>
      <div :class="progStep(index)">
        <!-- <small v-if="stateStep > index" style="width:100%;height:100%;display:flex;justify-content:center;align-items:center;">✓</small> -->
        <img v-if="stateStep > index" src="@/assets/check.png" style="width:80%;height:80%" />
      </div>
    </div>
  </div>
</template>

<script>

import { mapState } from 'vuex';

import Template from '@/lib/obTemplates';

export default {

  data(){
    return {

    }
  },

  computed: {
    steps(){
      return Template[this.$store.state.onboard.obEntity];
    },
    stateStep(){
      return this.$store.state.onboard.obStep;
    },
    clauses(){
      let lPref = this.$store.state.lang;
      let lang;
      switch (this.$store.state.onboard.obEntity) {
        case 'access':
          lang = 'RequestAccessTemplate';
        break;
        case 'bldg':
          lang = 'OnboardBuildingTemplate';
        break;
        case 'room':
          lang = 'OnboardRoomTemplate';
        break;
        case 'user':
          lang = 'OnboardUserComponent';
        break;
      }
      const Lang = require(`@/lib/langTemplates/${lang}`);
      return Object.keys(Lang.clauses).reduce((a, i) => {
        a[i] = Lang.clauses[i][lPref];
        return a;
      }, {});
    }
  },

  // computed: mapState({
  //   steps: state => Template[state.onboard.obEntity],
  //   stateStep: state => state.onboard.obStep
  // }),

  methods: {
    progStep(i){
      if (i < this.stateStep) {
        return 'prog prog-complete';
      } else {
        return i === this.stateStep ? 'prog prog-current' : 'prog prog-yet';
      }
    }
  }

}

</script>

<style>

  .prog-outer {
    width: 100%;
    height: 50px;
    display: flex;
    justify-content: space-around;
    align-items: center;
    margin-top: 8px;
  }

  .prog-node {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
  }

  .prog-node small {
    font-size: 0.75em;
  }

  .prog {
    width: 15px;
    height: 15px;
    border-radius: 100%;
    margin: 4px;
  }

  .prog-complete {
    background-color: rgb(0, 153, 191);
    border: 1px solid rgb(0, 153, 191);
  }

  .prog-current {
    width: 20px;
    height: 20px;
    background-color: #7ae989;
    border: 1px solid #7ae989;
  }

  .prog-yet {
    border: 1px solid lightgray;
  }

</style>



// WEBPACK FOOTER //
// src/components/onboard/Progress.vue